<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Notificações'"
    [titleIcon]="'pi pi-bell'"
    [subtitle]="'Acompanhe suas notificações e mantenha-se atualizado.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Notificações', icon: 'pi pi-bell' },
    ]">
    <div class="notifications__header-actions">
      <button type="button" class="notifications__mark-all" [disabled]="store.unreadCount() === 0"
        (click)="markAllRead()">
        Marcar todas como lidas
      </button>
    </div>
  </app-page-header>

  <div class="container-fluid notifications">
    <div class="notifications__filters">
      <button type="button" class="notifications__filter"
        [class.notifications__filter--active]="store.filter() === 'all'" (click)="setFilter('all')">
        Todas
      </button>
      <button type="button" class="notifications__filter"
        [class.notifications__filter--active]="store.filter() === 'unread'" (click)="setFilter('unread')">
        Não lidas
        @if (store.unreadCount() > 0) {
        <span class="notifications__filter-badge">{{ store.unreadCount() }}</span>
        }
      </button>
    </div>

    <div class="notifications__body">
      @if (store.loading()) {
      <p class="notifications__state">Carregando notificações...</p>
      } @else if (store.error()) {
      <p class="notifications__state">Não foi possível carregar as notificações.</p>
      } @else if (store.isEmpty()) {
      <div class="notifications__empty">
        <i class="pi pi-bell-slash"></i>
        <p>Você não tem notificações por aqui.</p>
      </div>
      } @else {
      <ul class="notifications__list">
        @for (notification of store.notifications(); track notification.id) {
        <li>
          <app-notification-item [notification]="notification" (read)="handleRead($event)"
            (openAction)="handleOpenAction($event)" />
        </li>
        }
      </ul>

      @if (store.totalCount() > store.pageSize()) {
      <p-paginator [first]="(store.currentPage() - 1) * store.pageSize()" [rows]="store.pageSize()"
        [totalRecords]="store.totalCount()" (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} de {totalRecords}" [showFirstLastIcon]="false"></p-paginator>
      }
      }
    </div>
  </div>
</app-layout>